import { render, staticRenderFns } from "./TurnstileWidget.vue?vue&type=template&id=56959a9e"
import script from "./TurnstileWidget.vue?vue&type=script&lang=js"
export * from "./TurnstileWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports